<template>
  <div>
    <!-- comprador -->
    <div class="card mb-3">
      <div class="card-header" @click="clickCollapseStep('datos-comprador')">
        <div class="row justify-content-between align-items-center">
          <div class="col-12 col-md-auto">
            <div class="card-title mb-0">{{ title }}</div>
          </div>
          <div class="col text-right" v-if="!isFeePayments">
            <button @click.stop.prevent="autocompleteUser(true)" class="btn btn-outline-secondary btn-sm mr-2" type="button">
              Usuario externo
            </button>
            <button
              v-if="cart.length > 0"
              @click.stop="autocompleteUser()"
              class="btn btn-outline-secondary btn-sm mr-2"
              type="button"
            >
              Entradas cortesía
            </button>
          </div>
          <div class="col-auto px-0 text-right">
            <i class="material-icons">expand_more</i>
          </div>
        </div>
      </div>
      <b-collapse id="datos-comprador" visible accordion="accordion-info">
        <div class="card-body">
          <!-- end facturacion -->
          <form @submit.prevent="verifyDataUserPay('datos-comprador')" ref="formBuyed" class="mb-3">
            <div class="row">
              <div class="col-12">
                <b-alert
                  :show="dismissCountDown"
                  dismissible
                  variant="warning"
                  @dismissed="dismissCountDown = 0"
                  @dismiss-count-down="countDownChanged"
                >
                  No se encontraron resultados.
                </b-alert>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6">
                <label class="form-group w-100">
                  <b>Tipo documento*</b>
                  <select
                    v-model="user.documentType"
                    :disabled="!haveEvents && isBilling"
                    type="text"
                    class="form-control"
                    @change="user.document = ''"
                    required
                  >
                    <option v-for="doc in docTypes" :value="doc" :key="doc">
                      {{ doc }}
                    </option>
                  </select>
                </label>
              </div>
              <div class="col-12 col-sm-6">
                <label class="form-group w-100">
                  <div class="d-flex justify-content-between">
                    <b>N° de documento*</b>
                    <small
                      v-if="user.documentType === 'DNI' && user.document && user.document.length < 8"
                      classs="mb-2"
                      style="color: #e53935 !important;"
                    >
                      Debe tener 8 dígitos
                    </small>
                  </div>
                  <b-input-group>
                    <b-form-input
                      v-model="user.document"
                      :disabled="!haveEvents && isBilling"
                      type="text"
                      class="form-control"
                      :maxlength="user.documentType === 'DNI' ? 8 : 14"
                      @keypress="user.documentType === 'DNI' ? onlyNumber($event) : alphaNumeric($event)"
                      @paste="user.documentType === 'DNI' ? handlePaste($event, 'numeric') : handlePaste($event, 'alphanumeric')"
                      required
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        variant="info"
                        :disabled="disabledSearchDocumentType"
                        @click="verifyUser(user.document, 'documentType')"
                        >Buscar</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6" v-if="showInputs">
                <label class="form-group w-100">
                  <b>Teléfono</b>
                  <input
                    v-model="user.phone"
                    :disabled="!haveEvents && isBilling"
                    type="text"
                    class="form-control"
                    @keypress="onlyNumber"
                    @paste="handlePaste($event, 'numeric')"
                    maxlength="9"
                  />
                </label>
              </div>
              <div class="col-12" :class="{'col-sm-6' : showInputs}">
                <label class="form-group w-100">
                  <b>Email*</b>
                  <b-input-group>
                    <b-form-input
                      v-model="user.email"
                      :disabled="!haveEvents && isBilling"
                      type="email"
                      class="form-control"
                      required
                      @paste="handlePaste($event, 'email')"
                      maxlength="60"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button variant="info" :disabled="disabledSearchEmail" @click="verifyUser(user.email, 'email')"
                        >Buscar</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </label>
              </div>
            </div>
            <template v-if="showInputs">
              <div class="row">
                <div class="col-12 col-sm-6">
                  <label class="form-group w-100">
                    <b>Nombres*</b>
                    <input
                      v-model="user.name"
                      :disabled="!haveEvents && isBilling"
                      type="text"
                      class="form-control"
                      required
                      @keypress="validateText($event, user.name)"
                      @paste="handlePaste($event, 'text')"
                      maxlength="50"
                    />
                  </label>
                </div>
                <div class="col-12 col-sm-6">
                  <label class="form-group w-100">
                    <b>Apellidos*</b>
                    <input
                      v-model="user.lastname"
                      :disabled="!haveEvents && isBilling"
                      type="text"
                      class="form-control"
                      required
                      @keypress="validateText($event, user.lastname)"
                      @paste="handlePaste($event, 'text')"
                      maxlength="50"
                    />
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-6">
                  <label class="form-group w-100">
                    <b>Género*</b>
                    <b-form-group :disabled="!haveEvents && isBilling">
                      <b-form-radio-group name="radio-inline" v-model="user.sexo" required>
                        <b-form-radio value="M">Masculino</b-form-radio>
                        <b-form-radio value="F">Femenino</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </label>
                </div>
              </div>
              <div class="row ml-1 mb-3">
                <b-form-checkbox id="checkbox-billing" v-model="isBilling" name="checkbox-billing">
                  Quiero factura
                </b-form-checkbox>
              </div>
              <div class="text-right" v-if="!isBilling">
                <button ref="formBuyedBtn" class="btn btn-action btn-lg" type="submit" :disabled="disabledNextUserData">
                  Continuar
                </button>
              </div>
            </template>
          </form>
          <!-- facturacion -->
          <div class="row">
            <div class="col-12 mb-3">
              <UserDataBuyBilling :billings="billings" @userBillingData="userBillingData($event)" v-if="isBilling" />
            </div>
            <div v-if="isBilling" class="col-12 mb-3 text-right">
              <button
                ref="formBuyedBtn"
                class="btn btn-action btn-lg"
                @click="verifyDataUserPay('datos-comprador')"
                :disabled="disabledNextUserData"
              >
                Continuar
              </button>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
    <!-- extrafields -->
    <div v-if="hasExtraFields" class="card mb-4">
      <div class="card-header py-2" @click="clickCollapseStep('datos-extras')">
        <div class="row justify-content-between align-items-center">
          <div class="col-auto">
            <div class="card-title mb-0">Datos extras</div>
          </div>
          <div class="col-auto px-0">
            <i class="material-icons">expand_more</i>
          </div>
        </div>
      </div>
      <b-collapse id="datos-extras" accordion="accordion-info">
        <div class="card-body">
          <form @submit.prevent="verifyDataUserPay('datos-extras')" class="row">
            <div v-for="(ef, idx) in eventSelected.extraFields" :key="idx" class="col-12 col-sm-6">
              <div v-if="ef.htmlTag === 'input'" >
                <b-form-group
                  class="form-item"
                  style="text-transform: capitalize"
                  :label="ef.fieldLabel + (ef.isRequired ? '*' : '') + (ef.valueType === 'phone' ? ' (+51987654321)' : '')"
                >
                  <b-form-input
                    v-model.trim="ef.value"
                    :placeholder="ef.possibleValues ? ef.possibleValues : ef.fieldLabel"
                    autocomplete="off"
                    :type="getResolvedType(ef.valueType)"
                    :minlength="ef.minInclusive ? ef.minInclusive : 2"
                    :maxlength="ef.fieldLabel.toLowerCase() === 'celular' ? 9 : ef.maxInclusive"
                    :required="Boolean(ef.isRequired)"
                    @keypress="validateInput($event, ef.valueType, ef.value)"
                  />
                </b-form-group>
              </div>
              <div v-if="ef.htmlTag === 'select'">
                <b-form-group
                class="form-item"
                :label="ef.fieldLabel + (ef.isRequired ? '*' : '')"
              >
                <b-form-select
                  v-model="ef.value"
                  :options="ef.possibleValues.split(',')"
                  :placeholder="ef.fieldLabel"
                  :required="Boolean(ef.isRequired)"
                />
              </b-form-group>
              </div>
            </div>
            <div class="col-12 text-right">
              <button class="btn btn-action btn-lg" type="submit">Continuar</button>
            </div>
          </form>
        </div>
      </b-collapse>
    </div>
    <!-- participants -->
    <div v-if="hasParticipants && !hideParticipant" class="card mb-4">
      <div class="card-header py-2" @click="clickCollapseStep('datos-participantes')">
        <div class="row justify-content-between align-items-center">
          <div class="col-auto">
            <div class="card-title mb-0">Datos de Participante(s)</div>
          </div>
          <div class="col-auto px-0">
            <i class="material-icons">expand_more</i>
          </div>
        </div>
      </div>
      <b-collapse id="datos-participantes" accordion="accordion-info">
        <div class="card-body">
          <form @submit.prevent="registerDataUser()">
            <div v-for="(item, idx) in participantsData" :key="idx">
              <h3 class="mt-4">
                <span>Participante #{{ idx + 1 }}</span>
                <button
                  v-if="idx === 0"
                  @click.stop.prevent="autocompleteParticipant({ idx })"
                  class="btn btn-outline-secondary btn-sm ml-3"
                  type="button"
                >
                  Usar datos del comprador
                </button>
                <button
                  @click.stop.prevent="autocompleteParticipant({ idx, external: true })"
                  class="btn btn-outline-secondary btn-sm ml-3"
                  type="button"
                >
                  Usuario externo
                </button>
              </h3>
              <div class="row">
                <div class="col-12 col-sm-6">
                  <label class="form-group w-100">
                    <div>Tipo documento*</div>
                    <select v-model="item.userdata.documentType" class="form-control" required>
                      <option v-for="doc in docTypes" :value="doc" :key="doc">
                        {{ doc }}
                      </option>
                    </select>
                  </label>
                </div>
                <div class="col-12 col-sm-6">
                  <label class="form-group w-100">
                    <div>N° de documento*</div>
                    <input
                      v-model.trim="item.userdata.document"
                      :ref="`doc${idx}`"
                      @blur="participantSearch(item, idx)"
                      type="text"
                      class="form-control"
                      :class="{ 'is-invalid': hasInvalidField('document', item) }"
                      required
                      @keypress="onlyNumber"
                    />
                  </label>
                </div>
                <div class="col-12 col-sm-6">
                  <label class="form-group w-100">
                   <div>Nombres*</div>
                   <input
                     v-model.trim="item.userdata.name"
                     type="text"
                     class="form-control"
                     required
                     @keypress="validateText($event, item.userdata.name)"
                   />
                 </label>
                </div>
                <div class="col-12 col-sm-6">
                  <label class="form-group w-100">
                    <div>Apellidos*</div>
                    <input
                      v-model.trim="item.userdata.lastName"
                      type="text"
                      class="form-control"
                      required
                      @keypress="validateText($event, item.userdata.lastName)"
                    />
                  </label>
                </div>
              </div>
              <hr />
            </div>
            <div class="text-right">
              <button class="btn btn-action btn-lg" type="submit">Continuar</button>
            </div>
          </form>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import api from '../api';
import { alphaNumeric, onlyNumber, verifyPhone, validateRequiredFields } from '../utils/helpers';
import { COURTESY_EMAIL, EXTERNAL_USER_EMAIL } from '../consts';

const docTypes = ['DNI', 'CE', 'PASS'];
export default {
  props: {
    title: {
      type: String,
      default: 'Datos del comprador',
    },
    profileIntimo: {
      type: Object,
      default: () => {},
    },
    eventSelected: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      docTypes,
      step: 'datos del comprador', // 0: datos del comprador, 1:datos extras  2: datos de participantes
      user: {
        name: '',
        lastname: '',
        email: '',
        document: '',
        documentType: 'DNI',
        phone: '',
        sexo: 'M',
        id: '',
      },
      participantsData: [],
      extraFields: [],
      isBilling: false,
      buycorporate: 0,
      //alert
      dismissSecs: 5,
      dismissCountDown: 0,
      showInputs: false,
    };
  },
  computed: {
    cart() {
      return this.$store.state.cart.cartEvents;
    },
    haveEvents() {
      return this.cart.length > 0;
    },
    hasParticipants() {
      return this.cart.filter((el) => el.listsParticipant).length;
    },
    hideParticipant() {
      if (!this.metaData) return false;
      const exist = this.metaData.dontListParticipant;
      return exist && exist.length > 0;
    },
    validateParticipants() {
      const { participantsData: users } = this;
      if (users.length > 0) {
        let valid = true;
        let invalidNom = false;
        users.forEach((el) => {
          if (!el.userdata.name || !el.userdata.lastName || !el.userdata.document) {
            valid = false;
          }
          invalidNom = this.hasInvalidField('document', el);
        });
        return valid && !invalidNom;
      }
      return true;
    },
    hasExtraFields() {
      return this.eventSelected && this.eventSelected.extraFields && this.eventSelected.extraFields.length > 0;
    },
    metaData() {
      return this.$store.getters.getMetadata;
    },
    isFeePayments() {
      return !!this.metaData.feePayments;
    },
    disabledNextUserData() {
      return this.verifyDataUserBilling();
    },
    disabledSearchDocumentType() {
      const documentType = this.user.documentType === 'DNI' ? 8 : 12
      return this.user.documentType && this.user.document && documentType ? false : true;
    },
    disabledSearchEmail() {
      return this.user.email && this.validateEmail(this.user.email) ? false : true;
    },
    billings() {
      return this.$store.getters.getBillings;
    },
    userBilling() {
      return this.$store.state.billing.userBilling;
    },
    userBill() {
      return this.$store.state.auth.user;
    },
  },
  watch: {
    cart: {
      handler(cart) {
        if (cart.length) {
          const allArr = [];
          const arrPar = this.cart.filter((el) => el.listsParticipant);
          arrPar.forEach((el) => {
            let quantity = el.value;
            if (el.type === 'venue') {
              quantity = quantity.split(',').length;
            }
            if (el.type === 'combo') {
              quantity = el.value * el.minQuantityPerOrder;
            }
            // eslint-disable-next-line
            for (let i = 0; i < quantity; i++) {
              // eslint-disable-next-line
              el.userdata = {
                name: '',
                lastName: '',
                documentType: 'DNI',
                document: '',
              };
              delete el.title;
              delete el.description;
              delete el.information;
              delete el.imageUrl;
              const clon = { ...el };
              allArr.push(clon);
            }
          });
          this.participantsData = allArr;
        }
      },
      inmediate: true,
      deep: true,
    },
    isBilling(value) {
      if (value) {
        // this.listBilling();
      } else {
        this.$store.dispatch('resetFormBilling');
      }
    },
  },
  methods: {
    onlyNumber,
    alphaNumeric,
    verifyPhone,
    validateInput(e, type, value){
      if(type === 'phone') {
        this.verifyPhone(e, value)
      } else if (type === 'number') {
        this.onlyNumber(e);
      }
    },
    getResolvedType(valueType) {
      const validTypes = ['text', 'password', 'email', 'number', 'date'];
      if (valueType === 'phone' || valueType === 'number') {
        return 'text';
      }
      return validTypes.includes(valueType) ? valueType : 'text';
    },
    setProfileIntimo(user) {
      this.user.name = user.firstName;
      this.user.lastname = user.lastName;
      this.user.email = user.email;
      this.user.document = user.dniUser;
      this.user.documentType = user.documentType;
      this.user.phone = user.phoneUser;
      this.user.sexo = user.gender.toUpperCase();
      this.user.id = user.id;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    userBillingData(value) {
      this.buycorporate = value;
    },
    verifyDataUserBilling() {
      if (this.isBilling) {
        const billing = this.userBilling || {};

        const requiredFieldsMissing = validateRequiredFields(billing).filter(el => el !== 'phone');
        const emailValid = this.validateEmail(billing.email || '');
        const rucValid = typeof billing.businessIdentifier === 'string' && billing.businessIdentifier.length === 11;

        return (
          requiredFieldsMissing.length > 0 ||
          !emailValid ||
          !rucValid
        );
      } else {
        const user = this.user || {};
        delete user.id;
        const requiredFieldsMissing = validateRequiredFields(user).filter(el => el !== 'phone');;
        const validDocumentLength = user.documentType === 'DNI' ? user.document.length === 8 : (user.document.length > 0 && user.document.length <= 14);
        const emailValid = this.validateEmail(user.email || '');
        const documentValid = typeof user.document === 'string' && validDocumentLength;

        return requiredFieldsMissing.length > 0 || !documentValid || !emailValid;
      }
    },
    clickCollapseStep(step){
      this.$root.$emit('bv::toggle::collapse', step);
      this.step = step;
    },
    autocompleteUser(external) {
      const user = {
        name: 'Entradas',
        lastname: 'Cortesía',
        email: COURTESY_EMAIL,
        document: '00000000',
        phone: '900000003',
        documentType: 'DNI',
      };
      if (external) {
        user.name = 'Usuario';
        user.lastname = 'Externo';
        user.email = EXTERNAL_USER_EMAIL;
        user.phone = '900000004';
      }
      this.user = { ...this.user, ...user };
      this.showInputs = true;
    },
    autocompleteParticipant({ idx, external }) {
      const { name, lastname, document: uDocument } = this.user;
      const ceros = 8 - String(idx).length;
      const document = new Array(ceros).fill().map(() => '0').join('') + (idx + 1);
      this.participantsData[idx].userdata = {
        name: external ? 'Usuario' : name,
        lastName: external ? 'Externo' : lastname,
        document: external ? document : uDocument,
        documentType: 'DNI',
      };
    },
    verifyDataUserPay(step) {
      if (this.isBilling && this.disabledNextUserData) return;
      const allSteps = ['datos-comprador', 'datos-extras', 'datos-participantes'];
      const collapses = ['datos-comprador'];
      if (this.hasExtraFields) {
        collapses.push('datos-extras');
      }
      if (this.hasParticipants && !this.hideParticipant) {
        collapses.push('datos-participantes');
      }

      if (!allSteps.includes(step) || !collapses.includes(step)) {
        return;
      }

      const currentIndex = collapses.indexOf(step);
      const remainingSteps = collapses.slice(currentIndex + 1);

      if (remainingSteps.length > 0) {
        const nextCollapse = remainingSteps[0];
        this.$root.$emit('bv::toggle::collapse', nextCollapse);
      } else {
        this.registerDataUser();
      }
    },
    async participantSearch(item, index) {
      const {
        userdata: { document, documentType },
      } = item;
      const payload = { document, documentType };
      if (document.length < 6) return;
      const { data: res } = await api.axios.post('/participants/search-by-document', payload);
      if (!res.status) {
        item.userdata.name = '';
        item.userdata.lastName = '';
      } else {
        item.userdata.name = res.data.name;
        item.userdata.lastName = res.data.lastName;

        const nextIdx = index + 1;
        if (this.participantsData.length > nextIdx) {
          this.$refs[`doc${nextIdx}`][0].focus();
        }

        if (this.hasInvalidField('document', item)) {
          item.userdata.document = '';
          item.userdata.name = '';
          item.userdata.lastName = '';
          this.$refs[`doc${index}`][0].focus();
        }
      }
    },
    hasInvalidField(field, item) {
      let counter = 0;
      this.participantsData.forEach((el) => {
        if (el.userdata[field] && el.userdata[field] === item.userdata[field]) {
          counter += 1;
        }
      });
      return counter > 1 && item.flagNominativeTickets;
    },
    registerDataUser() {
      if (!this.validateParticipants && !this.hideParticipant) return;
      const { user, participantsData, buycorporate } = this;
      this.$emit('submit', { user, participants: participantsData, buycorporate });
    },
    verifyUser(value, type) {
      this.isBilling = false;
      if (type === 'email') {
        const data = {
          filters: [
            {
              field: type,
              value: value,
            },
          ],
        };
        this.verifyUserApi(data);
      } else {
        const data = {
          filters: [
            {
              field: 'dniuser',
              value: value,
            },
            {
              field: type,
              value: this.user.documentType,
            },
          ],
        };
        this.verifyUserApi(data);
      }
    },
    async verifyUserApi(data) {
      try {
        this.$store.dispatch('changeLoadingJoinnus', true);
        const response = await api.verificationUser(data);
        if (response.userExists) {
          this.setDataVerifyUser(response.user);
        } else {
          // this.user.name = '';
          // this.user.lastname = '';
          // this.user.email = '';
          // this.user.document = '';
          // this.user.documentType = '';
          // this.user.phone = '';
          // this.user.sexo = 'M';
          // this.user.id = '';
          this.showAlert();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.showInputs = true;
        this.$store.dispatch('changeLoadingJoinnus', false);
      }
    },
    setDataVerifyUser(payload) {
      this.user.name = payload.firstName;
      this.user.lastname = payload.lastName;
      this.user.email = payload.email;
      this.user.document = payload.dniUser;
      this.user.documentType = payload.documentType;
      this.user.phone = payload.phoneUser;
      this.user.sexo = payload.gender.toUpperCase();
      this.user.id = payload.id;
    },
    async listBilling() {
      this.user.id = this.userBill.id;
      if (this.user.id) {
        this.$store.dispatch('setBillingUserId', this.user.id);
        try {
          this.$store.dispatch('changeLoadingJoinnus', true);
          const response = await api.getBillings(this.user.id);
          this.$store.dispatch('setBillings', response.userBillingDetails);
        } catch (error) {
          console.log(error);
        } finally {
          this.$store.dispatch('changeLoadingJoinnus', false);
        }
      } else {
        this.$store.dispatch('setBillings', []);
      }
    },
  },
  mounted() {
    if (this.profileIntimo) {
      this.setProfileIntimo(this.profileIntimo);
    }
  },
};
</script>

<style lang="scss" scoped>
.input-group-append {
  margin-left: -5px;
}
</style>
